
















import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { $t } from "@/lib/i18nHelpers";
import { formatMoneyString, getMainCurrencyCode } from "@/lib/moneyHelpers";
import { FormFields, FormValues, UploadVaultFile } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseForm from "@/components/BaseForm";

export default defineComponent({
  name: "EditCaptionConfirm",
  components: { BaseForm, BaseConfirm, BaseButton },
  props: {
    file: { type: Object as PropType<UploadVaultFile>, required: true },
    paymentPackages: { type: Array as PropType<PaymentPackage[]>, required: true },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const values = ref<FormValues>({
      pricePackageId: props.file.pricePackageId ?? "0",
      caption: props.file.caption ?? "",
    });

    const fields = computed<FormFields>(() => {
      const options = [{ text: $t("Free"), value: "0" }].concat(
        props.paymentPackages.map(packageData => ({
          text: formatMoneyString(packageData.amount, { currencyCode: getMainCurrencyCode() }),
          value: packageData.id,
        }))
      );

      return [
        {
          name: "pricePackageId",
          type: "select",
          options: options,
          rules: ["required"],
        },
        {
          name: "caption",
          placeholder: $t("No caption"),
          type: "textarea",
        },
      ];
    });

    const onSave = () => {
      loading.value = true;
      emit("updateFile", {
        file: props.file,
        caption: values.value.caption,
        pricePackageId: values.value.pricePackageId,
        cb: () => (loading.value = false),
      });
    };

    return { loading, fields, values, onSave };
  },
});
